import Reminders from './Reminders'
import * as constants from './constants'
import reducer from './reducer'

export default Reminders
export { constants, reducer }
